module.exports = __webpack_public_path__ + "img/taylord.229a69e4.jpg";